import { render, staticRenderFns } from "./scdy.vue?vue&type=template&id=2ff21e66&scoped=true&"
import script from "./scdy.vue?vue&type=script&lang=js&"
export * from "./scdy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff21e66",
  null
  
)

export default component.exports